import { render, staticRenderFns } from "./IcoCart.vue?vue&type=template&id=6f451dd0"
import script from "./IcoCart.vue?vue&type=script&lang=js"
export * from "./IcoCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports